// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gaming-habits .content{margin-top:8px}.gaming-habits .gaming-experience h4{margin-top:32px;margin-bottom:0}", ""]);
// Exports
module.exports = exports;
